import { render } from "./PrintReport.vue?vue&type=template&id=453c5148"
import script from "./PrintReport.vue?vue&type=script&lang=js"
export * from "./PrintReport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__